import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LinkPopupLocalization {

  private static readonly STYLE_ID = 'content-editor-link-popup-localization';

  private readonly applyButton = $localize`:@@communication-centre.advertiser.communication-editor.message-composer.button.apply:Apply`;
  private readonly editButton = $localize`:@@communication-centre.advertiser.communication-editor.message-composer.button.edit:Edit`;
  private readonly removeButton = $localize`:@@communication-centre.advertiser.communication-editor.message-composer.button.remove:Remove`;

  private readonly enterLinkLabel = $localize`:@@communication-centre.advertiser.communication-editor.message-composer.label.enter-link:Enter link`;
  private readonly visitLinkLabel = $localize`:@@communication-centre.advertiser.communication-editor.message-composer.label.visit-link:Visit link`;

  private readonly localizationStyles = `

    .ql-snow .ql-tooltip a.ql-action::after { 
      content: '${this.editButton}'; 
    }

    .ql-snow .ql-tooltip a.ql-remove::before { 
      content: '${this.removeButton}'; 
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after { 
      content: '${this.applyButton}'; 
    }

    .ql-snow .ql-tooltip::before { 
      content: '${this.visitLinkLabel}'; 
    }

    .ql-snow .ql-tooltip[data-mode='link']::before { 
      content: '${this.enterLinkLabel}'; 
    }
  `;

  public apply(): void {

    if (document.getElementById(LinkPopupLocalization.STYLE_ID)) {
      return;
    }

    const style = document.createElement('style');
    style.id = LinkPopupLocalization.STYLE_ID;
    style.innerHTML = this.localizationStyles;
    document.body.appendChild(style);
  }

}
